import { API } from 'aws-amplify';

import { getAuthHeaders } from 'actions';
import config from 'config';
import { replacer } from '../utils';

export const downloadKml = async ({ body, type }) => {
	const { url } = await API.post(
		'savant-api',
		replacer(config.apiEndpoints.kmlDownload, {
			type
		}),
		{
			headers: await getAuthHeaders(),
			body,
			responseType: 'text'
		}
	);

	// window.open(url, '_blank', 'download=test.kml');

	const a = document.createElement('a');
	//quotes removed since it doesn't work with npm package manager
	a.href = url.replace(/^"(.+(?="$))"$/, '$1');
	// a.setAttribute('download', `${id}.kml`);
	a.click();
	a.remove();
};
